export enum CustomExceptionTypes {
  LOGIN_ERROR,
  NEED_LOGIN,
  UNKNOWN_ERROR,
  SERVICE_ERROR,
  USER_INPUT_ERROR,
}
